import { Grid, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../../constants/FieldsConst';
import { validMessage } from '../../../../../constants/ValidsFormConst';
import { useNotification } from '../../../../../helpers/Notification';
import { LoadingWidget } from '../../../../../widgets';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import { saveEntHorarioClasesAction } from '../EntHorarioClasesAction';

const FormEntHorarioClases = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const entHorariosClasesStore = Redux.useSelector(
    (state) => state.entHorariosClases,
  );

  const activo = entHorariosClasesStore.activo;

  const initData = {
    nombre: '',
    start: '07:00',
    end: '18:00',
    totalDias: 5,
    totalBloques: 17,
    desc: '',
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nombre: false,
    start: false,
    end: false,
    totalBloques: false,
    totalDias: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    setTimeout(
      () =>
        setData({
          nombre: activo.nombre,
          start: activo.start,
          end: activo.end,
          totalDias: activo.totalDias,
          totalBloques: activo.totalBloques,
          desc: activo.desc,
        }),
      300,
    );
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (entidadesStore.activo === undefined || entidadesStore.activo === null) {
      notify('Falta seleccionar la entidad', { warning: true });

      return;
    }
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveEntHorarioClasesAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idEntidad: entidadesStore.activo.id,
        },
        entHorariosClasesStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave ?? (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.nombre.name}
            required
            label={CONST.nombre.label}
            value={data.nombre}
            onChange={(e) =>
              _handleSetDataField(
                CONST.nombre.name,
                e.target.value.toUpperCase(),
              )
            }
            helperText={dataError.nombre ? validMessage.required : null}
            error={dataError.nombre}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            type="number"
            label={CONST.totalDias.quest}
            value={data.totalDias}
            onChange={(e) =>
              _handleSetDataField(CONST.totalDias.name, e.target.value)
            }
            id={CONST.totalDias.name}
            InputProps={{
              inputProps: { min: 1 },
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            type="number"
            label={CONST.totalBloques.quest}
            value={data.totalBloques}
            onChange={(e) =>
              _handleSetDataField(CONST.totalBloques.name, e.target.value)
            }
            id={CONST.totalBloques.name}
            InputProps={{
              inputProps: { min: 1 },
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.start.name}
            required
            type="time"
            label={CONST.start.label}
            value={data.start}
            onChange={(e) =>
              _handleSetDataField(CONST.start.name, e.target.value)
            }
            helperText={dataError.start ? validMessage.required : null}
            error={dataError.start}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.end.name}
            required
            type="time"
            label={CONST.end.label}
            value={data.end}
            onChange={(e) =>
              _handleSetDataField(CONST.end.name, e.target.value)
            }
            helperText={dataError.end ? validMessage.required : null}
            error={dataError.end}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={4}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
            helperText={dataError.desc ? validMessage.required : null}
            error={dataError.desc}
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormEntHorarioClases;
